import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCard } from '@angular/material/card';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgFor, NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-filter-analysis-dialog',
    templateUrl: './filter-analysis-dialog.component.html',
    styleUrls: ['./filter-analysis-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatCard, MatLabel, MatFormField, MatInput, MatRadioGroup, MatRadioButton, MatSelect, NgFor, MatOption, MatDialogActions, MatButton, NgIf]
})
export class FilterAnalysisDialog implements OnInit {

  filterFormGroup:UntypedFormGroup;
  formattedData:any[] = [{ label: '', value: 0 }]; // To avoid console erorr, need to default the data to something.

  existingFilters:boolean;

  constructor(
    public dialogRef: MatDialogRef<FilterAnalysisDialog>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public inData: any
  ) { 
    console.debug("inData", inData);
    this.formattedData = inData.formattedData;

    this.existingFilters = (inData.valueFilters.length > 0 || inData.minDuration > 0) ? true : false;
    let disableValueFilters:boolean = inData.valueFilterType == 'all' ? true : false;

    // Populate the minimum duration
    this.filterFormGroup = this.fb.group({
      MinDuration: new UntypedFormControl({value: inData.minDuration, disabled: false}, Validators.required),
      ValueFilterType: new UntypedFormControl({value: inData.valueFilterType, disabled: false}),
      ValueFilters: new UntypedFormControl({value: inData.valueFilters, disabled: disableValueFilters})
    });


  }

  ngOnInit(): void {
    // Watch for changes in filter type, if include/exclude selected then enable the dropdown
    this.filterFormGroup.get('ValueFilterType').valueChanges.subscribe(
      selectedValue => {
        if (selectedValue == "all") {
          this.filterFormGroup.get('ValueFilters').reset();
          this.filterFormGroup.get('ValueFilters').disable();
        } else {
          this.filterFormGroup.get('ValueFilters').enable();
        }
      }
    );
  }

  clearFilters(): void {
    this.closeDialog(0,"all",[]);
  }

  filter(): void {
    let minDuration:number = this.filterFormGroup.get('MinDuration').value;
    let valueFilterType:string = this.filterFormGroup.get('ValueFilterType').value;
    let valueFilters:string[];

    if (valueFilterType == 'all') {
      valueFilters = [];
    } else {
      valueFilters = this.filterFormGroup.get('ValueFilters').value
    }

    this.closeDialog(minDuration, valueFilterType, valueFilters);
  }

  closeDialog(minDuration:number, valueFilterType:string, valueFilters:string[]): void {
    this.dialogRef.close({
                            updateFilter: true, 
                            minDuration: minDuration, 
                            valueFilterType: valueFilterType,
                            valueFilters: valueFilters
                          });
  }

  cancel():void {
    this.dialogRef.close({updateFilter: false});
  }

}
